module.exports = __webpack_public_path__ + "static/media/toyota-land.e17a2bdb.webp";